/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Category } from './';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface FamilyWithCategories
 */
export interface FamilyWithCategories {
    /**
     * 
     * @type {string}
     * @memberof FamilyWithCategories
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FamilyWithCategories
     */
    label: string;
    /**
     * 
     * @type {Array<Category>}
     * @memberof FamilyWithCategories
     */
    categories: Array<Category>;
}

/**
 * Check if a given object implements the FamilyWithCategories interface.
 */
export function instanceOfFamilyWithCategories(value: object): value is FamilyWithCategories {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    return true;
}

export function FamilyWithCategoriesFromJSON(json: any): FamilyWithCategories {
    return FamilyWithCategoriesFromJSONTyped(json, false);
}

export function FamilyWithCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyWithCategories {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'categories': ((json['categories'] as Array<any>).map(CategoryFromJSON)),
    };
}

export function FamilyWithCategoriesToJSON(value?: FamilyWithCategories | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'categories': ((value['categories'] as Array<any>).map((v) => CategoryToJSON(v))),
    };
}

